const Designation = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "designation": "Designation",

    // ERROR
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

}

export default Designation;
